import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { termsOfService } from '../data/termsOfService';

const TermsOfService = () => {
  const { lang } = useLanguage();
  const content = termsOfService[lang] || termsOfService.en;

  return (
    <div className="bg-zinc-950 min-h-screen pt-32 pb-24 px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-3xl mx-auto"
      >
        <Link
          to="/"
          className="text-orange-500 hover:text-orange-400 font-medium mb-12 inline-block transition-colors"
        >
          ← {lang === 'es' ? 'Volver al inicio' : 'Back to Home'}
        </Link>

        <h1 className="text-4xl md:text-5xl font-black text-white mb-4 tracking-tighter">
          {content.title}
        </h1>

        <p className="text-zinc-500 font-medium mb-12">
          {content.effective}
        </p>

        <div className="space-y-12">
          <p className="text-xl text-zinc-300 leading-relaxed">
            {content.intro}
          </p>

          {content.sections.map((section, index) => (
            <div key={index} className="space-y-4">
              <h2 className="text-2xl font-bold text-white tracking-tight">
                {section.h2}
              </h2>
              <p className="text-zinc-400 leading-relaxed text-lg whitespace-pre-line">
                {section.content}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-20 pt-12 border-t border-white/5">
          <p className="text-zinc-500 text-sm">
            &copy;{new Date().getFullYear()} Mathias Deppe. All rights reserved.
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default TermsOfService;